export default "__VITE_ASSET__69a23052__"